import Reveal from '@/components/base/Reveal';
import { heroStats, heroTicker } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative h-[560px] w-full overflow-hidden md:h-[680px]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20crimson%20smoke%20and%20warm%20amber%20light%20streaks%20swirling%20across%20a%20deep%20charcoal%20background%2C%20dramatic%20editorial%20poster%20art%20with%20high%20contrast%20and%20grainy%20film%20texture%2C%20cinematic%20moody%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20rich%20warm%20red%20and%20gold%20tones%2C%20full%20bleed%20composition&width=1600&height=900&seq=hlmf-hero-01&orientation=landscape"
          alt="黑料免费爆料内容主视觉背景"
          title="黑料免费 · 爆料内容公开开放不限量"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/45 to-foreground-950/75" />
        <div className="hero-glow pointer-events-none absolute -left-24 top-10 h-80 w-80 rounded-full bg-primary-500/25 blur-3xl" />

        <div className="relative z-10 flex h-full w-full items-center">
          <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
            <div className="max-w-[820px]">
              <Reveal>
                <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-[13px] tracking-wide text-background-100">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-shield-check-line text-[14px]" />
                  </span>
                  公开开放 · 无需付费 · 不限量观看
                </div>
              </Reveal>

              <Reveal delay={80}>
                <h2 className="font-heading text-[40px] font-black leading-[1.12] tracking-tight text-background-50 md:text-[64px]">
                  黑料免费
                  <span className="mt-2 block text-[22px] font-semibold leading-snug text-background-100 md:text-[30px]">
                    爆料内容全面开放，点开即看
                  </span>
                </h2>
              </Reveal>

              <Reveal delay={160}>
                <p className="mt-6 max-w-[640px] text-[15px] leading-relaxed text-background-100/85 md:text-[17px]">
                  无需付费、无门槛限制，公开不限量观看。影视、综艺、演出与商务动向的热门猛料持续更新，
                  满足你的吃瓜需求，全部条目直接可看。
                </p>
              </Reveal>

              <Reveal delay={240}>
                <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                  <a
                    href="#hot"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-[15px] font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className="ri-fire-line text-[18px]" />
                    </span>
                    立即看今日热榜
                  </a>
                  <a
                    href="#latest"
                    className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3.5 text-[15px] font-medium text-background-50 transition-colors hover:bg-background-50/10"
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <i className="ri-list-check-2 text-[18px]" />
                    </span>
                    浏览最新爆料
                  </a>
                </div>
              </Reveal>

              <Reveal delay={320}>
                <div className="mt-12 grid max-w-[620px] grid-cols-3 gap-4 border-t border-background-50/20 pt-7 md:gap-6">
                  {heroStats.map((stat) => (
                    <div key={stat.label}>
                      <div className="font-heading text-[26px] font-black text-accent-400 md:text-[34px]">
                        {stat.value}
                      </div>
                      <div className="mt-1 text-[12px] text-background-100/70 md:text-[13px]">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>

      {/* 实时快讯滚动条 */}
      <div className="w-full border-y border-background-300/70 bg-background-100">
        <div className="mx-auto flex max-w-[1400px] items-center gap-4 px-4 md:px-6">
          <div className="flex shrink-0 items-center gap-2 border-r border-background-300 py-3 pr-4">
            <span className="flex h-4 w-4 items-center justify-center text-primary-600">
              <i className="ri-flashlight-fill text-[15px]" />
            </span>
            <span className="whitespace-nowrap text-[13px] font-medium text-primary-600">实时快讯</span>
          </div>
          <div className="relative w-full overflow-hidden py-3">
            <div className="ticker-track gap-10">
              {[...heroTicker, ...heroTicker].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="flex items-center gap-2 whitespace-nowrap text-[13px] text-foreground-700"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}